<template>
    <div class="layout-default">
        <WebHeader v-if="webInfo.id === 'hzc'"></WebHeader>
        <WebHeaderHzyc v-if="webInfo.id === 'hzyc'"></WebHeaderHzyc>

        <div class="def-hzc">
            <div
                class="view"
                :class="{gray}"
            >
                 <nuxt />
            </div>
        </div>

        <WebFooter></WebFooter>

        <chat :themeColor="webInfo.themeColor" :topTitleLogo="webInfo.iconUrl"  :customerLogo="webInfo.iconUrl"></chat>

        <!-- <DialogReservation></DialogReservation> -->

        <!-- <onlineServe></onlineServe> -->

    </div>
</template>

<script>
import WebHeader from '@/components/sys/header.vue';
import WebHeaderHzyc from '@/components/sys/header-hzyc.vue';
import WebFooter from '@/components/sys/footer.vue';
import DialogReservation from '@/components/sys/dialog-reservation.vue';
import onlineServe from '@/components/sys/layout/online-serve.vue';
import chat from '@/components/sys/chat/index.vue'


export default {
    props: {
        gray: {
            type: Boolean,
            default: false,
        },
    },
    
    components: {
        WebHeader,
        WebHeaderHzyc,
        WebFooter,
        DialogReservation,
        onlineServe,
        chat,
    },
};
</script>

<style lang="scss" scoped>
.layout-default {
    min-width: 1200px;
}
</style>

